<script setup lang="ts">
import { onMounted, ref, useTemplateRef } from 'vue'
import { ILayoutOptions } from './types/layout'
import { RouterView } from 'vue-router'
import bus from '@/utils/bus'
import { invoke } from '@kiti/js-bridge'
import { useLayoutStoreHook } from '@/stores/modules/layout'

const layoutStore = useLayoutStoreHook()

const appMain = useTemplateRef<HTMLElement>('appMain')

const layoutOptions = ref<ILayoutOptions>()
/**
 * @description: 获取布局配置
 * @return {*}
 */
const getLayoutOptions = async (retryCount = 0) => {
  try {
    const res = await invoke<ILayoutOptions>('getLayoutOptions')

    // 检查获取的height是否为0
    if (res?.statusBar?.height === 0 && retryCount < 3) {
      const delay = (retryCount + 1) * 1000 // 1s, 2s, 3s

      console.warn(`布局配置获取失败，height为0，${delay / 1000}秒后重试...`)

      setTimeout(() => {
        getLayoutOptions(retryCount + 1)
      }, delay)
      return
    }

    layoutOptions.value = res
    layoutStore.initStatusBarHeight(layoutOptions.value)
  } catch (error) {
    console.warn('获取布局配置失败:', error)

    // 如果是网络错误等，也可以进行重试
    if (retryCount < 3) {
      const delay = (retryCount + 1) * 1000

      console.warn(`获取布局配置异常，${delay / 1000}秒后重试...`)

      setTimeout(() => {
        getLayoutOptions(retryCount + 1)
      }, delay)
    }
  }
}

onMounted(() => {
  getLayoutOptions()
  appMain.value?.addEventListener(
    'scroll',
    e => {
      bus.emit('mainScroll', e)
    },
    {
      passive: true
    }
  )
})
</script>

<template>
  <TitleBar title="novalander" />

  <main
    ref="appMain"
    class="app-main"
  >
    <RouterView />
  </main>

  <div class="safe-area-bottom-height" />
</template>

<style>
.app-main {
  flex: 1;
  overflow: auto;
  z-index: 10;
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 200px;
}
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  .spinner {
    width: 40px;
    height: 40px;
    border: 4px solid rgba(248, 78, 63, 0.1);
    border-radius: 50%;
    border-top-color: #f84e3f;
    animation: spin 1s ease-in-out infinite;
  }
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
